/**
 * these are errors that Sentry.io will capture but are not indicative of
 * something broken in the application.
 *
 * capturing those errors here so they aren't spamming us with notifications.
 */
export const IGNORE_ERRORS = [
  // typical when a user switches views in the middle of an API request
  'TypeError: Failed to fetch',
  // ResizeObserver was not able to deliver all observations within a single
  // animation frame. it is benign
  'ResizeObserver loop limit exceeded',
]
